import { useQuery } from "react-query";
import constants from "../../../utils/constants";
import servicesUtils from "../../../utils/servicesUtils";
import { transformPermittedUsers } from "../transformers/transformPermittedUsers";
export var useAllPermittedUsers = function useAllPermittedUsers() {
  var permission = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : constants.WORKSPACE_USER_ROLES.WORKSPACE_PATIENT_READ;
  var fetchFunction = function fetchFunction() {
    return servicesUtils.getService("/all_permitted_accounts/?permission=".concat(permission)).then(function (data) {
      return {
        users: transformPermittedUsers(data)
      };
    });
  };
  return useQuery(["permittedWorkspaceUsers"], fetchFunction);
};